module.exports = __webpack_public_path__ + "img/warrning_icon_2.1e106001.png";